module.exports = __webpack_public_path__ + "static/media/07-rules-popup.e1a6a55f.png";